<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    :footer="null"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #user_realname>
        <a-input
          v-decorator="[
            'user_realname',
            { rules: [{ required: true, message: '请输入真实姓名' }] }
          ]"
          placeholder="请输入真实姓名"
        />
      </template>
      <template #user_nickname>
        <a-input
          v-decorator="[
            'user_nickname',
            { rules: [{ required: true, message: '请输入昵称' }] }
          ]"
          placeholder="请输入昵称"
        />
      </template>
      <template #sex>
        <a-radio-group
          v-decorator="[
            'sex',
            { rules: [{ required: true, message: '请选择性别' }] }
          ]"
        >
          <a-radio :value="1">
            男
          </a-radio>
          <a-radio :value="2">
            女
          </a-radio>
        </a-radio-group>
      </template>
      <template #address>
        <province-city
          v-decorator="[
            'provinceCity'
          ]"
        />
        <!-- {
              rules: [{ required: true, validator: checkProvinceCity }]
            } -->
      </template>
      <template #mobile>
        <a-input
          v-decorator="[
            'mobile',
            {
              rules: [
                { required: true, message: '请输入手机号码' },
                {
                  pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                  message: '请输入正确的手机号码'
                }
              ]
            }
          ]"
          placeholder="请输入手机号码"
        />
      </template>
      <template #introduction>
        <a-textarea
          v-decorator="[
            'introduction',
            { rules: [{ required: true, message: '请输入' }] }
          ]"
          rows="3"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
import ProvinceCity from './../components/ProvinceCity';
export default {
  components: { ProvinceCity },
  props: ['title', 'visible', 'typeId'],
  data() {
    return {
      formData,
      typeData: [
        { id: 1, name: '药企' },
        { id: 2, name: '服务商' },
      ],
      companyData: [],
    };
  },
  watch: {
    typeId(val) {
      this.onChangeType(val);
    },
  },
  mounted() {},
  methods: {
    // 获取企业
    async getCompanyData(url) {
      let result = await this.$http.post(url);
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item) => {
          return { name: item.team_name?item.team_name:item.companyInfo.qichacha_name, ...item };
        });
        this.companyData = data;
      }
    },
    // 选择企业类型
    async onChangeType(value) {
      console.log('onChangeType -> value', value);
      if (value === 0) {
        this.companyData = [{ id: 0, name: '所有公司' }];
      } else if (value === 1) {
        this.getCompanyData('/company/getCompanyList');
      } else {
        this.getCompanyData('/ServiceProvider/getCompanyList');
      }
    },
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      const error = [];
      if (!value || !value.province) {
        error.push('省份');
      }
      if (!value || !value.city) {
        error.push('城市');
      }
      if (error.length === 0) {
        callback();
      }
      callback(`请选择${error.join('和')}`);
    },
  },
};
</script>
